import React, { Component } from 'react';
import { BrowserRouter, Route, Link } from 'react-router-dom';

import '../styles/InstructorSelector.css';


class InstructorSelector extends Component {
    constructor(props) {
        super(props);
        let _instructors = props.getInstructors();
        let _selected = (props.selected) ? props.selected : _instructors[0].eidHash;
        this.state = { instructors: _instructors,
            selectInstructor: props.selectInstructor, selected: _selected };
        // props.selectInstructor(_selected);
    }

    _selectInstructor(event) {
        let target = (event.target.tagName.toLowerCase() === 'div') ? event.target : event.target.parentNode;
        if (this.state.selected !== target.id) {
            this.setState({selected: target.id});
            this.state.selectInstructor(target.id);
        }
    }

    _getRealGPA(gpa) {
        gpa = gpa.toFixed(2);
        return (gpa > 0) ? gpa : ' N/A '
    }

    _renderInstructors() {
        // console.log(this.state.selected);
        const instructors = (!this.state.instructors) ? (<div></div>) :
            ((this.state.instructors.length > 0) ?
                this.state.instructors.map((instructor) => {
                    let classNames = 'instructor-selector-block';
                    if (instructor.eidHash === this.state.selected) classNames += ' selected'; // TODO
                    return (
                        <div id={ instructor.eidHash } key={ instructor.eidHash } className={ classNames }
                             onClick={ this._selectInstructor.bind(this) } >
                            <Link to={'/instructor/' + instructor.eidHash} className="">
                                { instructor.name }
                            </Link><br />
                            <span onClick={ this._selectInstructor.bind(this) } >
                                Avg GPA <b>{ this._getRealGPA(instructor.average) }</b>
                          </span>
                        </div>
                    )}) : <div className="instructor-selector-block">No section info found.</div> // TODO: className
            );
        return (
            <div className="instructor-selector-wrapper">
                { instructors }
            </div>
        );
    }

    render() {
        const instructors = this._renderInstructors();
        // console.log(this.state.selected);
        return (
            <div className='instructor-selector-container scrollbar'>
                { instructors }
            </div>
        ); // TODO
    }

    componentDidMount() {
        // scroll to the selected div
        let selected = document.getElementsByClassName('selected');
        if (selected.length > 0) {
            selected = selected[0];
            let scrollbar = document.getElementsByClassName('scrollbar')[0];
            scrollbar.scrollLeft = selected.offsetLeft - scrollbar.offsetLeft;
        }
    }
}

export default InstructorSelector;



// WEBPACK FOOTER //
// ./src/components/InstructorSelector.js